module.exports = __webpack_public_path__ + "static/gingerbreadbooties-edf629a65cf57b53e6ffde542f436b93.jpeg";